module.exports = __webpack_public_path__ + "img/zeigling5.ea6c4a4c.jpg";